import React from 'react';
import { useFormContext } from '@atlassian/jira-issue-create-form-context';
import { IssueRestore, type IssueRestoreChildren } from '@atlassian/jira-issue-create-restore';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal';

type IssueRestoreWrapperProps = {
	children?: IssueRestoreChildren;
};

export const IssueRestoreWrapper = ({ children }: IssueRestoreWrapperProps) => {
	const [, { restoreState: restoreTriggerIssueCreateModalState }] = useTriggerIssueCreateModal();
	const [, { restoreState: restoreFormContext }] = useFormContext();

	return (
		<IssueRestore
			onRestoreTriggerIssueCreateModalState={restoreTriggerIssueCreateModalState}
			onRestoreFormContext={restoreFormContext}
		>
			{children}
		</IssueRestore>
	);
};
